import { Controller } from "@hotwired/stimulus"

// Chips de la página de sección (dentro del frame): al entrar, la grilla nueva queda bajo la barra pegada y
// el activo centrado; el tocado se marca y centra al instante. Doc: storefront_catalog.md → "Página de sección"
export default class extends Controller {
  connect() {
    this.#startBelowBar()
    this.#center(this.element.querySelector(".active"), "auto")
    this.frame = this.element.closest("turbo-frame")
    this.onMissing = event => this.#followRedirect(event)
    this.frame?.addEventListener("turbo:frame-missing", this.onMissing)
  }

  disconnect() {
    this.frame?.removeEventListener("turbo:frame-missing", this.onMissing)
  }

  // click: marca el chip tocado y lo centra; el frame que llega lo confirma
  select(event) {
    const chip = event.currentTarget
    this.element.querySelectorAll(".active").forEach(other => {
      other.classList.remove("active")
      other.removeAttribute("aria-current")
    })
    chip.classList.add("active")
    chip.setAttribute("aria-current", "page")
    this.#center(chip, "smooth")
  }

  // La página venía desplazada (barra pegada): sube lo justo para que la grilla empiece bajo la barra
  #startBelowBar() {
    const grid = this.element.nextElementSibling
    if (!grid) return
    const stuckTop = parseFloat(getComputedStyle(this.element).top) || 0
    const delta = grid.getBoundingClientRect().top - (stuckTop + this.element.getBoundingClientRect().height)
    if (delta < 0) window.scrollBy(0, delta)
  }

  // La sección ya no está en la vitrina: Rails redirigió a la tienda y el frame no vino. Se sigue la
  // redirección como visita que reemplaza la pantalla (la app no apila otra tienda), no "Content missing"
  #followRedirect(event) {
    const { response, visit } = event.detail
    if (!response.redirected) return
    event.preventDefault()
    visit(response.url, { action: "replace" })
  }

  #center(chip, behavior) {
    if (!chip) return
    const nav = this.element.getBoundingClientRect()
    const rect = chip.getBoundingClientRect()
    const left = this.element.scrollLeft + (rect.left - nav.left) - (nav.width - rect.width) / 2
    this.element.scrollTo({ left: Math.max(0, left), behavior })
  }
}
